import { Link, useNavigate } from 'react-router-dom';
import { colors } from '../lib/theme';
import { useAuth } from '../context/AuthContext';

interface Props {
  open: boolean;
  onClose: () => void;
}

const ITEMS: { to: string; label: string; badge?: string }[] = [
  { to: '/upgrade', label: 'Upgrade to PRO', badge: 'Coming soon' },
  { to: '/onboarding', label: 'How to use' },
  { to: '/settings', label: 'Settings' },
  { to: '/contact', label: 'Contact us' },
];

export default function SideMenu({ open, onClose }: Props) {
  const { logout } = useAuth();
  const navigate = useNavigate();

  async function handleLogout() {
    onClose();
    await logout();
    navigate('/login');
  }

  return (
    <>
      <div
        onClick={onClose}
        aria-hidden="true"
        style={{
          position: 'fixed',
          inset: 0,
          background: 'rgba(26, 24, 21, 0.35)',
          opacity: open ? 1 : 0,
          pointerEvents: open ? 'auto' : 'none',
          transition: 'opacity 0.2s ease',
          zIndex: 40,
        }}
      />
      <div
        style={{
          position: 'fixed',
          top: 0,
          right: 0,
          bottom: 0,
          width: 280,
          maxWidth: '85vw',
          background: colors.bone,
          boxShadow: '-4px 0 20px rgba(0,0,0,0.15)',
          transform: open ? 'translateX(0)' : 'translateX(100%)',
          transition: 'transform 0.25s ease',
          zIndex: 50,
          display: 'flex',
          flexDirection: 'column',
          padding: '1.25rem 1rem',
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '0.75rem' }}>
          <button
            onClick={onClose}
            aria-label="Close menu"
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              fontSize: '1.4rem',
              lineHeight: 1,
              padding: '0.25rem',
              color: '#1a1815',
            }}
          >
            ×
          </button>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
          {ITEMS.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              onClick={onClose}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '0.5rem',
                textDecoration: 'none',
                color: colors.lavenderText,
                background: colors.lavender,
                borderRadius: 14,
                padding: '0.75rem 1rem',
                fontWeight: 600,
              }}
            >
              {item.label}
              {item.badge && (
                <span
                  style={{
                    fontSize: '0.7rem',
                    fontWeight: 700,
                    background: 'rgba(255,255,255,0.6)',
                    borderRadius: 999,
                    padding: '0.15rem 0.5rem',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {item.badge}
                </span>
              )}
            </Link>
          ))}

          <button
            type="button"
            onClick={handleLogout}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
              textAlign: 'left',
              textDecoration: 'none',
              color: colors.redText,
              background: colors.red,
              border: 'none',
              borderRadius: 14,
              padding: '0.75rem 1rem',
              fontWeight: 600,
              fontSize: '1rem',
              cursor: 'pointer',
              fontFamily: 'inherit',
            }}
          >
            Log out
          </button>
        </div>
      </div>
    </>
  );
}
